import React from "react";
import styles from "./Timer.module.css";
import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";

const toArabicNumbers = (num) => {
  const arabicNumbers = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
  return num.toString().replace(/\d/g, (d) => arabicNumbers[d]);
};

// Function to get Arabic or English labels
const getLabels = (lang) => {
  return lang === "ar"
    ? ["يوم", "ساعة", "دقيقة", "ثانية"] // Arabic labels
    : ["Days", "Hours", "Minutes", "Seconds"]; // English labels
};

const Timer = ({ time, onComplete, language }) => {
  const labels = getLabels(language);

  return (
    <div className={styles.timer}>
      {/* <FlipClockCountdown to={time} hideOnComplete={true}  onComplete={onComplete}>
            </FlipClockCountdown> */}

      <FlipClockCountdown
        to={time}
        hideOnComplete={true}
        onComplete={onComplete}
        labelStyle={{ fontSize: "16px" }} // Adjust label style
        labels={labels} // Set translated labels
        renderMap={(num) => (language === "ar" ? toArabicNumbers(num) : num)} // Convert numbers if Arabic
      />
    </div>
  );
};

export default Timer;
